const getOr = require('lodash/fp/getOr');
const merge = require('lodash/fp/merge');
const base64 = require('base-64');
const parseRequestMetaData = require('../utils/parse-request-meta-data');
const config = require('../config'); const apiConfig = require('../api-config');

const headers = { Accept: 'application/json' }
const defaultOpts = { headers, method: 'POST', json: true };

function parseValueMovement(data) {
   if((!data) || data.length==0){
     return null;
    }
    else {
      return JSON.stringify(data);
    }
}

function downLoadExcelContent ({ metaData, requestBody }, requestHandler) {
  // data formation
  const meta = parseRequestMetaData(metaData);
  const branchCode = meta.portfolio.branchCode === 999999999? meta.configBranchCode : meta.portfolio.branchCode;
  const parsedRequestBody = JSON.parse(base64.decode(requestBody))
  const request = {
    method: 'POST',
    url: `${config.baseUrl}/excelexports/${apiConfig.apiversion}/excel-content`,
    Accept: 'application/json',
    headers: merge(headers, meta.headers),
    body: {
      userId: meta.qs.userId,
      branchCode: branchCode,
      fromDate: parsedRequestBody.fromDate,
      reportname: parsedRequestBody.reportname,
      toDate: parsedRequestBody.toDate,
    },
    json: true,
  }
  // serialize
  return requestHandler(request)
    .then(parseValueMovement)
    .catch(() => null)
}

function addRoutes({ requestHandler } = {}) {
  return app => app
    .match(`[{keys:metaData}].positionDownloads.downloads[{keys:requestBody}].[{keys:ran_str}]`, requests => {
      return Promise.all(requests.map(
        ({ req, res }) => downLoadExcelContent(req.params, requestHandler)
        .then(response => res.value(response))
      ))
    }

    )
}

module.exports = addRoutes
